<template>
  <section class="home-bed">
    <div class="img-bed">
      <black-bar :ifCanBack="false" title="充值">
      </black-bar>
    </div>
    <img src="../assets/img/noAccess/icon_success.png"
         alt=""
         style="margin-top:4vh">
    <p>充值成功</p>
    <div class="line"></div>
    <ul>
      <li>
        <div class="key">订单号</div>
        <div class="val">{{orderInfo.orderNo}}</div>
      </li>
      <li>
        <div class="key">充值金额</div>
        <div class="val">{{orderInfo.price/100}}元</div>
      </li>
      <li>
        <div class="key">充值时间</div>
        <div class="val">{{orderInfo.time}}</div>
      </li>
    </ul>

    <div class="btn"
         @click="complete">完成</div>
  </section>
</template>

<script>
import blackBar from '@/components/blackBar'
export default {
  name: 'paySuccess',
  data () {
    return {
      loading: true,
      num: 20,
      orderInfo: {}
    }
  },
  components: {
    blackBar
  },
  created () {
    // if (window.sessionStorage.getItem('token')) {
    //   this.loading = true
    // }
  },
  mounted () {
    var that = this;
    window.paySuccess = that.paySuccess;

  },
  methods: {
    paySuccess (val) {

      if (val.code == '0000') {
        this.orderInfo = val.data;
      } else {
        this.$eventBus.$emit('getTipsInfo', {
          msg: val.message
        })
      }
    },
    goRouter (router) {
      if (this.loading) {
        this.$router.push({
          name: router
        })
      }
    },
    complete() {
      window.android.clickPaySuccess(true)
    }
  }
}
</script>

<style lang="scss" scoped>
.home-bed {
  // background: #eee;
  min-height: 100%;
  overflow: scroll;
  position: relative;
  text-align: center;
}
.img-bed {
  font-size: 0;
  margin-bottom: 12px;
  background: #fff;
  position: relative;
  width: 100%;
  // height: 320px;
  > div {
    position: absolute;
    margin: 0 auto;
    width: 100%;
    padding: 20px 0;
    text-align: center;
    background-color: #666;
  }
  img {
    width: 100%;
  }
}
p {
  font-size: 40px;
  font-weight: 500;
  color: #333333;
  margin-top: 24px;
}
img {
  width: 100px;
  height: 100px;
}
.line {
  width: 92%;
  margin-left: 4%;
  border: 1px dashed #999999;
  margin-top: 60px;
}

.btn {
  position: absolute;
  left: 0;
  bottom: 80px;
  width: 92%;
  margin-left: 4%;
  height: 98px;
  line-height: 98px;
  background: #4a8ef7;
  box-shadow: 0px 6px 20px 1px rgba(63, 138, 247, 0.2);
  border-radius: 49px 49px 49px 49px;
  font-size: 32px;
  font-weight: 400;
  color: #ffffff;
}
ul {
  width: 92%;
  margin-left: 4%;
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  li {
    display: flex;
    align-items: center;
    height: 37px;
    margin-bottom: 24px;
    font-size: 26px;
    .key {
      width: 120px;
      font-weight: 500;
      color: #282b29;
      text-align: left;
    }
    .val {
      width: calc(100% - 120px);
      font-weight: 400;
      color: #666666;
      text-align: right;
    }
  }
}
</style>
